import * as React from "react";
import PricingInfoPackageSwitchBlock from "./pricing-info-package-switch-block";
import PricingInfoPackageTrialInfo from "./pricing-info-package-trial-info";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

interface PricingInfoBlockProps {
  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TO TRIGER ON LINK CLICK */
  linkClickEventType?: GoogleAnalyticsEventType
}

interface PricingInfoBlockState {}

class PricingInfoBlock extends React.Component<PricingInfoBlockProps,PricingInfoBlockState> {

  constructor(props: PricingInfoBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onLinkClick = this.onLinkClick.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onButtonClick() {
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  onLinkClick() {
    if (this.props.linkClickEventType) {
      googleAnalyticsService.trackEvent(this.props.linkClickEventType);
    }
  }

  render() {
    return (
      <div onMouseEnter={this.onComponentView}>
        <PricingInfoBlockWrapper>
          <PricingInfoPackageWrapper>
            <PricingInfoPackageSwitchBlock onButtonClick={this.onButtonClick} onLinkClick={this.onLinkClick}/>
            <PricingInfoPackageTrialInfo/>
          </PricingInfoPackageWrapper>
        </PricingInfoBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const PricingInfoBlockWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  @media (min-width : 993px) {
    padding-right: 40px;
    padding-left: 40px;
    margin-top: 100px;
  }
`;

const PricingInfoPackageWrapper = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
    @media (max-width : 993px) {
      flex-direction: column-reverse;
      padding-right: 40px;
      padding-left: 40px;
    }
  }
`;

export default PricingInfoBlock


// WEBPACK FOOTER //
// ./src/layouts/pricing-info-block/pricing-info-block.tsx